import LtCommon from '../../../types/lt/ltCommon';

export default class TrainerizeUrlService {
	public static getTrainerizeUrl(params: LtCommon.IParamsObject): string {
		const queryString = Object.keys(params).map(key => key + '=' + encodeURIComponent(params[key])).join('&');
		const url = this.baseUrl + 'app/switchinto.ashx' + '?' + queryString;

		return url;
	}

	public static getTrainerizeUrlLogin(params: LtCommon.IParamsObject): string {
		const queryString = Object.keys(params).map(key => key + '=' + encodeURIComponent(params[key])).join('&');
		const url = this.baseUrl + 'app/Logon.aspx' + '?' + queryString;

		return url;
	}

	private static baseUrl = window.lt.globalPageDrivers.global.trainerize;
}
